import { connectStateResults } from 'react-instantsearch-dom';
import styles from './generalStateResults.module.scss';
import CustomArticleHits from '../hits/articleHits/articleHits';
import CustomPageHits from '../hits/pageHits/pageHits';

const GeneralStateResults = ({ locale, searchState, searchResults, globals }) => {
  const hasResults = searchResults && searchResults.nbHits !== 0 && searchState.query;
  const noSearchDone = !searchState.query;

  return (
    <div className={styles.generalStateResultsWrapper}>
      <CustomArticleHits
        locale={locale}
        searchQuery={searchState.query}
        noSearchDone={noSearchDone}
        hasResults={hasResults}
        resources={globals}
      />
      <CustomPageHits
        locale={locale}
        searchQuery={searchState.query}
        noSearchDone={noSearchDone}
        hasResults={hasResults}
        resources={globals}
      />
    </div>
  );
};

const CustomGeneralStateResults = connectStateResults(GeneralStateResults);

export default CustomGeneralStateResults;
